import { Transition } from '@uirouter/angularjs';
import { RegisterService, REGISTER_SERVICE } from './register.service';
import { IFormController, IOnChangesObject, IComponentController } from "angular";
import { StateService } from '@uirouter/angularjs';

import "./register.less";

export class RegisterController implements IComponentController {
    // from router
    private emailAndTicket: { email: string, ticket: string };
    private form: IFormController;
    private username: string;
    private password: string;
    private confirmPassword: string;
    private wait: boolean;

    private activationSent: boolean;

    //Labels
    get registrationLabel() { return "Account registration"; }
    get passwordLabel() { return "Password"; }
    get usernameLabel() { return "Username"; }
    get confirmedPassword() { return "Confirm password"; }
    get submitButtonLabel() { return "Submit"; }
    get activationSentLabel() { return "An activation email has been sent!"; }
    get activateLabel() { return "Please check your inbox and click the link in the email."; }
    get closeButtonLabel() { return "Close"; }

    //Form Messages
    get isRequiredMsg() { return "This is required!"; }


    static $inject = ["$mdToast", "$state", "$window", REGISTER_SERVICE];
    constructor(private $mdToast: ng.material.IToastService, private $state: StateService, private $window: ng.IWindowService, private registerService: RegisterService) {
        this.activationSent = false;
    }

    private register() {
        if (this.password !== this.confirmPassword) {
            return this.$mdToast.show(this.$mdToast.simple().textContent("Password and confirm password doesn't match.").position("top right").hideDelay(false));
        }
        this.wait = true;
        this.username = this.emailAndTicket.email.substr(0, this.emailAndTicket.email.indexOf('@'));

        return this.registerService.register(this.emailAndTicket.email, this.emailAndTicket.email, this.password, this.emailAndTicket.ticket).then(() => {
            this.activationSent = true;
        }, reason => {
            this.wait = false;
            return this.$mdToast.show(this.$mdToast.simple().textContent(reason.data.message).position("top right").hideDelay(false));
        }).finally(() => {
            this.wait = false;
        });
    }
}


// WEBPACK FOOTER //
// ./app/register/register.controller.ts